import Config from "./utils/Config";
import Admin from "./admin/Admin";

const App = () => {
    return <Admin/>
};

export default App;
